import React from 'react';
import { Core, Form } from 'connex-cds';
import styled from 'styled-components';
import { useGetTicketSignature } from '../../useTicketSignature';

const Image = styled.img`
  height: 65px;
  top: 10px;

  -webkit-filter: var(--signature-image-invert);
  filter: var(--signature-image-invert);
`;

export const DynamicWaiverSignatureImage = () => {
  const { values } = Form.useFormContext();

  const signatureUrl = React.useMemo(
    () => values?.dynamicWaiverSignature?.image,
    [values?.dynamicWaiverSignature?.image]
  );
  const { image, isLoading } = useGetTicketSignature({ signatureUrl });

  if (!image) {
    return null;
  }

  return (
    <Core.Spinner spin={isLoading}>
      <Image src={image} />
    </Core.Spinner>
  );
};
